'use client';
import React from 'react';
import { toast } from 'sonner';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';

const favorites = [
{
  id: 'fav-001',
  name: 'Caramel Latte',
  customization: 'Grande · Yulaf Sütü · Ekstra Karamel',
  price: 89,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b34fa3d2-1767830235117.png",
  alt: 'Caramel Latte — karamel soslu espresso içeceği',
  lastOrdered: '3 gün önce'
},
{
  id: 'fav-002',
  name: 'Caramel Chiller',
  customization: 'Venti · Sütsüz · Karamel Şurubu',
  price: 99,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_148018cc6-1784301377839.png",
  alt: 'Caramel Chiller — Gloria Jean\'s imza soğuk blended kahve',
  lastOrdered: '1 hafta önce'
},
{
  id: 'fav-003',
  name: 'Hazelnut Latte',
  customization: 'Grande · Badem Sütü · Yok',
  price: 87,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cbd075a9-1767678422590.png",
  alt: 'Hazelnut Latte — fındık aromalı sütlü kahve',
  lastOrdered: '2 hafta önce'
},
{
  id: 'fav-004',
  name: 'Sezonluk Baharatlı Latte',
  customization: 'Tall · Tam Yağlı Süt · Karamel',
  price: 95,
  image: "https://images.unsplash.com/photo-1633607957150-de1ce7e95c64",
  alt: 'Sezonluk Baharatlı Latte — tarçın aromalı sıcak kahve',
  lastOrdered: '1 ay önce'
}];


export default function FavoriteDrinks() {
  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-foreground font-bold text-base">Favori İçeceklerim</h2>
        <Link href="/menu-order" className="text-primary text-xs font-semibold">Menüye Git</Link>
      </div>
      {favorites?.length === 0 ?
      <div className="flex flex-col items-center py-10 text-center">
          <Icon name="HeartIcon" size={40} className="text-muted-foreground mb-2" />
          <p className="text-foreground font-semibold mb-1">Henüz favori yok</p>
          <p className="text-muted-foreground text-sm mb-3">Sipariş verirken kalp ikonuna basarak favorilerinize ekleyin</p>
          <Link href="/menu-order" className="bg-primary text-white px-4 py-2 rounded-full text-sm font-semibold">
            Menüyü Keşfet
          </Link>
        </div> :

      <div className="space-y-3">
          {favorites?.map((fav) =>
        <div key={fav?.id} className="bg-card rounded-2xl p-3 card-shadow flex items-center gap-3">
              <AppImage
            src={fav?.image}
            alt={fav?.alt}
            width={56}
            height={56}
            className="w-14 h-14 rounded-xl object-cover flex-shrink-0" />
          
              <div className="flex-1 min-w-0">
                <p className="text-foreground font-bold text-sm">{fav?.name}</p>
                <p className="text-muted-foreground text-xs truncate">{fav?.customization}</p>
                <p className="text-muted-foreground text-[10px] mt-0.5">Son sipariş: {fav?.lastOrdered}</p>
              </div>
              <div className="flex flex-col items-end gap-2">
                <span className="text-foreground font-bold text-sm">₺{fav?.price}</span>
                <button
              onClick={() => toast?.success(`${fav?.name} sepete eklendi!`)}
              className="w-7 h-7 rounded-full bg-primary text-white flex items-center justify-center hover:bg-primary/90 transition-colors active:scale-90">
              
                  <Icon name="PlusIcon" size={14} className="text-white" />
                </button>
              </div>
            </div>
        )}
        </div>
      }
    </div>);

}